import React, { useState } from "react"
import { Form, Input, Button, message, Divider, Flex } from "antd"
import { useUser } from "../../contexts/UserContext"

const ResetPassword = () => {
    const { resetPassword } = useUser()
    const [form] = Form.useForm()
    const [loading, setLoading] = useState(false)

    const handleSubmit = async (values) => {
        setLoading(true)
        const { username } = values
        const result = await resetPassword(username)
        setLoading(false)
        if (result.success) {
            message.success("Återställningsmail skickat.")
            form.resetFields()
        } else {
            message.error(result.message || "Misslyckades med att skicka återställningsmail.")
        }
    }

    return (
        <Flex style={{ flexWrap: "wrap", flexDirection: "column", alignContent: "center" }}>
            <h1 style={{ width: "300px", textAlign: "center" }} >Återställ lösenord</h1>
            <Form form={form} onFinish={handleSubmit} style={{ width:"300px"}}>
                <Divider />
                <Form.Item name="username" rules={[{ required: true, message: "Ange E-Mail" }]}>
                    <Input placeholder="E-Mail" />
                </Form.Item>
                <Button style={{width: "100%"}} type="primary" htmlType="submit" loading={loading}>
                    Begär återställning
                </Button>
            </Form>
        </Flex>
    )
}

export default ResetPassword
